import BasePublicApiClient from '@/clients/BasePublicApiClient'

class ContactDetailsClient extends BasePublicApiClient {
  getContactDetails (practiceUuid, locationUuids) {
    return this.client.post('/contact_details/v1/mp-contact-details/get-many', {
      practice_uuid: practiceUuid,
      entity_uuids: locationUuids
    }).then(response => {
      return response.data.contact_details
    })
  }
}

export default ContactDetailsClient
